import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { PRIVACY_POLICY_LINK } from '../../../services/constants';

import useStyles from './style';

const SignInPolicyDescription: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.signInPolicyDescription}>
      <div
        className={classes.headInfo}
        dangerouslySetInnerHTML={{
          __html: t('signInPolicyDescription', { link: PRIVACY_POLICY_LINK }),
        }}
      />
      {t('bySigningUpInfo')}
    </div>
  );
};

export default SignInPolicyDescription;
